<template lang="pug">
  .v-input.v-text-field.theme--light
    .v-input__control
      .v-input__slot
        .v-text-field__slot
          label.v-label.theme--light(aria-hidden='true', style='left: 0px; right: auto; position: absolute;')
          vue-google-autocomplete#map(placeholder='Address', v-on:placechanged='getAddressData')
      .v-text-field__details
        .v-messages.theme--light
          .v-messages__wrapper
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import { mapGetters } from 'vuex'
export default {
  props: ['initAddress'],
  data() {
    return {
      Address: {
        address: null,
        city: null,
        stateID: null,
        zipCode: null,
        country: null,
        latitude: null,
        longitude: null,
      }
    }
  },
  mounted() {
    $('#map').val(this.initAddress)
  },
  components: {
    VueGoogleAutocomplete,
  },
  computed: {
    ...mapGetters('global', ['states']),
  },
  methods: {
    getAddressData(addressData, placeResultData) {
      // console.log('addressData', addressData)
      // console.log('placeResultData', placeResultData)
      this.Address.zipCode = addressData.postal_code
      this.Address.country = addressData.country
      this.Address.address = `${addressData.street_number} ${addressData.route}`
      $('#map').val(this.Address.address)
      this.Address.latitude = addressData.latitude
      this.Address.longitude = addressData.longitude
      placeResultData.address_components.map(route => {
        if(route.types[0] === "neighborhood") this.Address.city = route.long_name
        if(route.types[0] === "administrative_area_level_1") {
          this.states.map(s => {
            if (s.stateSymbol === route.short_name) this.Address.stateID = s.stateID
          })
        }
      })
      this.$emit('addressSubmit', this.Address)
    }
  }
}
</script>

<style scoped>
</style>